import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import "./PathReview.scss"
import {requestTableDataReview, reviewAccountAction} from "../Store/ReviewAccountsStore";


function PathReviewAccount(props) {
  const data = useSelector(s => s.reviewAccountReducer);

  const dispatch = useDispatch();


  const pathClickHandler = (singlePassedAccount, incomeAccountCode, pathArray) => {



    dispatch(reviewAccountAction.fillInput({
      selectedRowAccountCode: {accountCode: incomeAccountCode}
    }))

    if(pathArray.length===0){
      dispatch(reviewAccountAction.fillInput({
        isItFirstTimeToRequestLink: true,
      }))
    }
    dispatch(
      requestTableDataReview(
        {
          level: singlePassedAccount.level,
          prevLevel: singlePassedAccount.prevLevel,
          accountCode: singlePassedAccount.accountCode,
          mode: singlePassedAccount.mode,
          downToUpType: singlePassedAccount.downToUpType,
          passedLevels: singlePassedAccount.passedLevels,
          passedAccounts: singlePassedAccount.passedAccounts,
          path: pathArray,
          filters: JSON.stringify(data.filterValues)
        }))


  }

  try {
    return (
      <div className={'path__section'}>
        {<div className={'d-flex my-1 '}>

          {data?.myData?.path?.length > 0 && <div className={'d-flex flex-wrap'}>
            {data.myData.path.map((v, index) => <div


              onClick={() => {


                let pathArray = [...data.myData.path]
                // اگه آخری بود دو تا کم کن
                if (index === data.myData.path.length - 1) {
                  pathArray?.pop()
                  pathArray?.pop()
                }
                // یکی  مونده به آخری   2+1 کم کن
                if (index === (data.myData.path.length - 1) - 1) {
                  pathArray?.pop()
                  pathArray?.pop()
                  pathArray?.pop()
                }
                // دو تا مونده به آخری   2+2 کم کن
                if (index === (((data.myData.path.length - 1) - 1) - 1)) {
                  pathArray?.pop()
                  pathArray?.pop()
                  pathArray?.pop()
                  pathArray?.pop()
                }


                pathClickHandler(data.myData.path[index - 1], v.accountCode, pathArray)
              }}
            >
              {v?.accountName && // or maby index!==0
                <div className={'position-relative'}>
                  {index!==0 && index!==1 &&
                    <div className={'before__text'}>
                    <i className="arrow left bg__white"></i>

                  </div>}
                  <div key={index} className={'mx-1   path__button bg__dadada'}>
                    {v?.accountName} {/*JSON.stringify(v)*/}

                  </div>

                  <div className={'after__text '}>
                    <i className="arrow left bg__dadada"></i>

                  </div>


                </div>}

            </div>)}
          </div>}
        </div>}
      </div>
    );
  } catch (error) {
    return <div style={{fontFamily: 'serif,tahoma '}}>{error.toString()}</div>
  }
}

export default PathReviewAccount;